var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9V3.5C4 2.94772 4.44772 2.5 5 2.5H30.5C31.0523 2.5 31.5 2.94772 31.5 3.5V9",
    stroke: "#8A96A3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 24.2319V33.7768C4 34.5446 4.82949 35.026 5.49615 34.645L17.5039 27.7833C17.8113 27.6076 18.1887 27.6076 18.4961 27.7833L30.5039 34.645C31.1705 35.026 32 34.5446 32 33.7768V24.2602",
    stroke: "#8A96A3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54894 13.9271C3.8483 13.0057 5.1517 13.0057 5.45106 13.9271L5.73483 14.8004C5.8687 15.2124 6.25266 15.4914 6.68588 15.4914H7.60419C8.57291 15.4914 8.97568 16.731 8.19197 17.3004L7.44905 17.8402C7.09856 18.0948 6.9519 18.5462 7.08578 18.9582L7.36955 19.8316C7.6689 20.7529 6.61442 21.519 5.83071 20.9496L5.08779 20.4098C4.7373 20.1552 4.2627 20.1552 3.91221 20.4098L3.16929 20.9496C2.38558 21.519 1.3311 20.7529 1.63045 19.8316L1.91422 18.9582C2.0481 18.5462 1.90144 18.0948 1.55095 17.8402L0.808031 17.3004C0.0243176 16.731 0.427093 15.4914 1.39582 15.4914H2.31412C2.74734 15.4914 3.1313 15.2124 3.26517 14.8004L3.54894 13.9271Z",
    fill: "#8A96A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5489 13.9271C17.8483 13.0057 19.1517 13.0057 19.4511 13.9271L19.7348 14.8004C19.8687 15.2124 20.2527 15.4914 20.6859 15.4914H21.6042C22.5729 15.4914 22.9757 16.731 22.192 17.3004L21.449 17.8402C21.0986 18.0948 20.9519 18.5462 21.0858 18.9582L21.3695 19.8316C21.6689 20.7529 20.6144 21.519 19.8307 20.9496L19.0878 20.4098C18.7373 20.1552 18.2627 20.1552 17.9122 20.4098L17.1693 20.9496C16.3856 21.519 15.3311 20.7529 15.6305 19.8316L15.9142 18.9582C16.0481 18.5462 15.9014 18.0948 15.551 17.8402L14.808 17.3004C14.0243 16.731 14.4271 15.4914 15.3958 15.4914H16.3141C16.7473 15.4914 17.1313 15.2124 17.2652 14.8004L17.5489 13.9271Z",
    fill: "#8A96A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5489 13.9271C31.8483 13.0057 33.1517 13.0057 33.4511 13.9271L33.7348 14.8004C33.8687 15.2124 34.2527 15.4914 34.6859 15.4914H35.6042C36.5729 15.4914 36.9757 16.731 36.192 17.3004L35.449 17.8402C35.0986 18.0948 34.9519 18.5462 35.0858 18.9582L35.3695 19.8316C35.6689 20.7529 34.6144 21.519 33.8307 20.9496L33.0878 20.4098C32.7373 20.1552 32.2627 20.1552 31.9122 20.4098L31.1693 20.9496C30.3856 21.519 29.3311 20.7529 29.6305 19.8316L29.9142 18.9582C30.0481 18.5462 29.9014 18.0948 29.551 17.8402L28.808 17.3004C28.0243 16.731 28.4271 15.4914 29.3958 15.4914H30.3141C30.7473 15.4914 31.1313 15.2124 31.2652 14.8004L31.5489 13.9271Z",
    fill: "#8A96A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/Collections.f7ea0b2ecf4cdc4887a5ebe12d58905c.svg";
export { ForwardRef as ReactComponent };